import SiteVue from './vueCode.js';
import Site from './site.js';
import barba from '@barba/core';
import GoogleAnalytics from '../vendor/catapult/googleAnalytics_v2.0.1.js';
import { TweenLite } from "gsap/TweenMax";

const Barba_controller = {

    init: function(){


      "use strict";

      // define a global hook

      barba.hooks.before(function (data) {
        console.log('global-before');
      });
      barba.hooks.beforeLeave(function (data) {
        console.log('global-beforeLeave');
      });
      barba.hooks.leave(function (data) {
        console.log('global-leave');
        GoogleAnalytics.postPage();
      });
      barba.hooks.afterLeave(function (data) {
        console.log('global-afterLeave');
      });
      barba.hooks.afterLeave(function (data) {
        console.log('global-afterLeave');
        SiteVue.destroyPageVue();
      });
      barba.hooks.beforeEnter(function (data) {
        console.log('global-beforeEnter');
        SiteVue.vuePage.setupPage($(data.next.container).data('pageinfo'));
        SiteVue.vueMenu.setupMenu($(data.next.container).data('pageinfo'));
      });
      barba.hooks.enter(function (data) {
        SiteVue.initPageVue(data.next.container);
        console.log('global-enter');
      });
      barba.hooks.afterEnter(function (data) {
        console.log('global-afterEnter');
      });
      barba.hooks.after(function (data) {
        console.log('global-after');
        SiteVue.vuePage.setupPage($(data.next.container).data('pageinfo'));
      //  Scroll_reveal.scan_scrollreveal();
      });




      barba.hooks.beforeOnce(function (data) {
        console.log('global-beforeOnce');
      });
      barba.hooks.once(function (data) {
        console.log('global-once');
      //  Scroll_reveal.init();

    //    const done = this.async();

    //    window.setTimeout(done, 1000);
      });

      barba.hooks.afterOnce(function (data) {
        console.log('global-afterOnce');
        SiteVue.vueMenu.setShowMenu(true);
        SiteVue.vuePage.setupPage($(data.next.container).data('pageinfo'));
        SiteVue.vueMenu.setupMenu($(data.next.container).data('pageinfo'));

      });


      barba.init({
        debug: true,
        cacheIgnore: [''],
        preventRunning: true,

        // prevent: function({ el }){
        //    el.classList && el.classList.contains('prevent'),
        // },

        transitions: [

          {
                  sync: false,
                  name: 'default',
                  leave: function(data) {

                    var done = this.async();

                    TweenLite.fromTo(".transition", 0.5,
                      {x: '-100%'},
                      {x: '0%',
                      onComplete: done
                    });

                  },
                  enter: function(data) {
                    var done = this.async();
                    Site.resetScrollPosition();

                    $(data.current.container).css({display: 'none'});

                    TweenLite.fromTo(".transition", 0.5,
                      {x: '0%'},
                      {x: '100%',
                      onComplete: done
                    });

                  },
                  beforeOnce: function beforeOnce(data){
                    console.log('default-beforeOnce');
                  },
                  once: function once(data){
                    console.log('default-once');
                  },
                  afterOnce: function afterOnce(data){
                    console.log('default-afterOnce');
                  },
                  before: function before(data) {
                  },
                  beforeAppear: function beforeAppear(data) {
                  },
                  afterAppear: function afterAppear(data) {
                  },
                  beforeLeave: function beforeLeave(data) {
                  },
                  afterLeave: function afterLeave(data) {
                  },
                  beforeEnter: function beforeEnter(data) {
                  },
                  afterEnter: function afterEnter(data) {
                  },
                  after: function after(data) {
                  }
          }

        ],


        views: [

          {
            name: '404',
            namespace: 'error',
            // Do leave and enter concurrently.
            sync: false,
            // Available hooks…
            beforeLeave: function beforeLeave(data) {
            },
            afterLeave: function afterLeave(data) {
            },
            beforeEnter: function beforeEnter(data) {
            },
            afterEnter: function afterEnter(data) {
            }
          },



          {
            name: 'homepage',
            namespace: 'homepage',
            // Do leave and enter concurrently.
            sync: false,
            // Available hooks…
            beforeLeave: function beforeLeave(data) {
            },
            afterLeave: function afterLeave(data) {

            },
            beforeEnter: function beforeEnter(data) {
  //            Site.setupScrollAnimation();
            },
            afterEnter: function afterEnter(data) {
            }
          },


          {
            name: 'darkpage',
            namespace: 'page',
            // Do leave and enter concurrently.
            sync: false,
            // Available hooks…
            beforeLeave: function beforeLeave(data) {
            },
            afterLeave: function afterLeave(data) {
              // Site.darkPage();
            },
            beforeEnter: function beforeEnter(data) {
              // Site.setupScrollAnimation();
            },
            afterEnter: function afterEnter(data) {
            }
          },

          {
            name: 'lightpage',
            namespace: 'page',
            // Do leave and enter concurrently.
            sync: false,
            // Available hooks…
            beforeLeave: function beforeLeave(data) {
            },
            afterLeave: function afterLeave(data) {
              // Site.lightPage();
            },
            beforeEnter: function beforeEnter(data) {
              // Site.setupScrollAnimation();
            },
            afterEnter: function afterEnter(data) {
            }
          }


        ]

      });
    }
};

export default Barba_controller;
